class NewProductForm extends HTMLElement {
  constructor() {
    super();   
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');

    this.candyAddons = this.querySelector("#candy-selection-content fieldset")
    this.candyLimit = 3
    this.candyAddons ? this.candyAddons.addEventListener("change", this.handleCandyChange.bind(this)) : ''

    this.cardSelector = this.closest("product-section").querySelector("product-card-model")

    this.subscribeButton = this.querySelector("button[type='button'][data-subscribe]")
    this.subscribeButton.addEventListener("click", this.onSubscribeClick.bind(this))

    this.addonRemotes = this.querySelectorAll("[data-addon-remote]")
    this.addonRemotes.forEach( r => {
      r.addEventListener("click", this.handleAddonRemote.bind(this))
    })
  }

  onSubscribeClick() {
    let urlBase = this.subscribeButton.dataset.url + (this.subscribeButton.dataset.url.indexOf('?') !== -1 ? '&' : '?') + `variant_id=${this.querySelector("[name='id']").value}&product_id=${this.querySelector("[name='product-id']").value}&selling_plan=3013312548`
    window.location.href = urlBase;
  }

  handleAddonRemote() {
    const addonId = event.target.dataset.addonRemote
    const addonInput = this.querySelector(`input[value="${addonId}"]`)
    console.log(addonId, addonInput)

    if(addonInput) {
      addonInput.checked = true
      console.log(addonInput)
    }

    const modalId = event.target.closest('.modal').id
    if(modalId) {
      MicroModal.close(modalId)
    }
  }

  handleCandyChange(event) {
    const candyCount = this.querySelectorAll("[name='Candy Addons']:checked").length
    if(candyCount > this.candyLimit) {
      // disable other inputs
      event.target.checked = false
    } else if(candyCount == this.candyLimit) {
      this.candyAddons.classList.add("selection-full")
    } else {
      // allow click on other inputs
      this.candyAddons.classList.remove("selection-full")
    }
  }

  handleCardSelection(event) {
    event.preventDefault();

    this.cardSelector._open()
    this.cardSelector.querySelector("button[type='submit'][name='add']").addEventListener("click", this.handleCardSubmit.bind(this))

    this.cardSelector.querySelector("form").addEventListener("submit", (event) => {
      event.preventDefault()
      console.log(event, "Prevent submit")
    })
  }

  handleCardSubmit(event) {
    event.preventDefault()
    console.log(event, "Handle card submit", this)

    // get card form data

    const cardFormData = new FormData(this.cardSelector.querySelector("form"))
    console.log(Object.fromEntries(cardFormData))

    // get card title from form
    const cardTitle = this.cardSelector.querySelector("input[name='id']:checked").dataset.title || this.cardSelector.querySelector("input[name='id']").dataset.title

    const cardItem = {'id': cardFormData.get('id'), 'quantity': 1, 'properties': {'_title': cardTitle, 'Message': cardFormData.get('properties[Message]')}}

    // then submit product form with card form data passed in
    this.onSubmitHandler(null,cardItem)
    this.cardSelector._close(true)
  }

  onSubmitHandler(event, card, giftieCompleted = false) {
    event ? event.preventDefault() : '';

    const submitButton = this.querySelector('[type="submit"]');

    if (
      !giftieCompleted
      && window.FreshsendsGiftie
      && window.FreshsendsGiftie.shouldIntercept(this.form, submitButton)
    ) {
      window.FreshsendsGiftie.startProductFlow({
        form: this.form,
        productId: submitButton.dataset.productId || '',
        onSaved: (giftieCard) => this.onSubmitHandler(null, giftieCard, true),
        onError: (message) => this.handleErrorMessage(message),
      });
      return;
    }

    submitButton.classList.add('loading');

    this.clearErrorMessage();
    this.errors = false;

    const config = fetchConfig('javascript');
    const formData = new FormData(this.form);
    const currentTime = new Date().getTime();

    if (this.cartDrawer) {
      formData.append(
        'sections',
        this.getSectionsToRender().map((section) => section.section)
      );
      formData.append('sections_url', window.location.pathname);
    }

    // ---- UPDATED: support multiple addon elements/groups ----
    // We will collect:
    //  - checkboxes named "Addons" (gift add-ons)
    //  - checkboxes named "Candy Addons" (candy selections)
    //  - radio group named "VaseAddon" (single selection; ignore if empty)
    //
    // If you later duplicate addon blocks and change names to "Addons-1", "Addons-2",
    // this also supports those patterns.

    const collectByNamePrefix = (prefix) => {
      const values = [];
      for (const [key, value] of formData.entries()) {
        if (!value) continue;
        if (key === prefix || key.startsWith(prefix + '-')) values.push(value);
      }
      return values;
    };

    const addons = collectByNamePrefix('Addons');                 // checkbox(es)
    const candyAddons = collectByNamePrefix('Candy Addons');      // checkbox(es)

    // Vase radio (single)
    const vaseAddon = formData.get('VaseAddon'); // returns "" when "No vase" is selected

    // Merge + de-dupe
    const allAddons = [...new Set([
      ...addons,
      ...candyAddons,
      ...(vaseAddon ? [vaseAddon] : [])
    ])];

    // ---- Build items ----
    const items = [];

    const mainProduct = {
      id: formData.get('id'),
      quantity: 1,
      'product-id': formData.get('product-id'),
      properties: { _main_product: currentTime }
    };

    if (card) {
      mainProduct.properties.With = card.properties._title;
    }

    items.push(mainProduct);

    allAddons.forEach((variantId) => {
      items.push({
        id: variantId,
        quantity: 1,
        properties: {
          _uniq_id: currentTime,
          _uniq_var_id: currentTime,
          For: formData.get('For'),
          _upsell: true
        }
      });
    });

    if (card) {
      card.properties._uniq_id = currentTime;
      card.properties.For = formData.get('For');
      items.push(card);
    }

    const body = {
      items,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };

    config.body = JSON.stringify(body);

    const diagnostic = {
      surface: 'product_page', groupId: currentTime,
      variantId: card?.id || mainProduct.id,
      sessionId: card?.properties?._giftie_greeting_card_session_id,
      designId: card?.properties?._giftie_greeting_card_design_id,
    };
    diagnostic.operationId = window.FreshsendsCartDiagnostics?.('cart_add_started', diagnostic);
    let diagnosticDone = false;
    let diagnosticReason = 'network_error';

    fetch('/cart/add.js', config)
      .then((response) => {
        diagnostic.httpStatus = response.status;
        diagnosticReason = response.ok ? 'invalid_response' : 'http_error';
        return response.json();
      })
      .then((parsedState) => {
        diagnosticDone = true;
        const addedCard = Array.isArray(parsedState.items) && card
          ? parsedState.items.find(item =>
            String(item.properties?._giftie_greeting_card_session_id || '') === String(card.properties._giftie_greeting_card_session_id)
            && String(item.properties?._uniq_id || '') === String(currentTime))
          : undefined;
        window.FreshsendsCartDiagnostics?.(
          parsedState.status || diagnostic.httpStatus >= 400 ? 'cart_add_failed' : 'cart_add_succeeded',
          { ...diagnostic, key: addedCard?.key, _uniq_id: addedCard?.properties?._uniq_id,
            reason: parsedState.status || diagnostic.httpStatus >= 400 ? 'http_error' : undefined }
        );
        if (parsedState.status) {
          this.errors = parsedState.message;
          this.handleErrorMessage(parsedState.message);
          return;
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML =
            getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });

        document.dispatchEvent(new CustomEvent('cart:update', {
          detail: { source: 'freshsends-product-form', cartData: parsedState },
        }));
      })
      .catch((e) => {
        if (!diagnosticDone) window.FreshsendsCartDiagnostics?.('cart_add_failed', { ...diagnostic, reason: diagnosticReason });
        console.error(e);
      })
      .finally(() => {
        const openCart = !this.errors;

        if (openCart) {
          this.cartDrawer.open();
        }

        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }


  handleErrorMessage(errors = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error');
    this.errorMessageText = this.errorMessageText || this.querySelector('.product-form__error-message');
    let errorText = errors.replace('Send on Send on', 'Send on').replace('Validation failed: ', '');

    if (this.errorMessageWrapper && this.errorMessageText && errorText) {
      this.errorMessageWrapper.setAttribute('aria-hidden', false);
      this.errorMessageText.innerHTML = errorText;
    }
  }

  clearErrorMessage() {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error');
    if (this.errorMessageWrapper) this.errorMessageWrapper.setAttribute('aria-hidden', true);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
};

customElements.define('new-product-form', NewProductForm);


class NewProductGallery extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.activeIndex = 0

    this.thumbs = this.querySelectorAll("[data-thumb]")
    this.mainSlides = this.querySelectorAll("[data-main-slide]")

    this.visibleSlides = this.getVisibleSlides()

    if(!this.visibleSlides[0].classList.contains('is-active')) {
      this.updateActiveIndex(this.findNewIndex(this.visibleSlides[0].classList.contains('is-active')))
    }

    this.thumbs.forEach((thumb, index) => {
      thumb.addEventListener("mouseenter", this.handleThumb.bind(this))
      thumb.addEventListener("click", this.handleThumb.bind(this))
    })

    /* ── Mobile arrows navigation ── */
    this.mobileNav = this.querySelector('.main-product-2026__mobile-nav');
    this.prevBtn = this.querySelector('.main-product-2026__mobile-prev');
    this.nextBtn = this.querySelector('.main-product-2026__mobile-next');

    if (this.prevBtn) this.prevBtn.addEventListener("click", this.handlePrevious.bind(this))
    if (this.nextBtn) this.nextBtn.addEventListener("click", this.handleNext.bind(this))
    this.updateMobileNavVisibility()
  }

  updateActiveIndex(i) {
    if(i == NaN) return
    this.activeIndex = i
    this.updateActiveImage()
  }

  findNewIndex(slide) {
    const index = Array.from(this.mainSlides).indexOf(slide)
    return index
  }

  updateActiveImage() {
    this.thumbs.forEach( thumb => { thumb.classList.remove("is-active")})
    this.mainSlides.forEach( slide => { slide.classList.remove("is-active")})

    if(this.thumbs[this.activeIndex]) {
      this.thumbs[this.activeIndex].classList.add('is-active')
      this.thumbs[this.activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
    }

    if(this.mainSlides[this.activeIndex]) this.mainSlides[this.activeIndex].classList.add('is-active')
    this.updateMobileNavVisibility()
  }

  updateMobileNavVisibility() {
    if (!this.mobileNav) this.mobileNav = this.querySelector('.main-product-2026__mobile-nav');
    if (!this.mobileNav) return;
    const visibleCount = this.getVisibleSlides().length;
    this.mobileNav.classList.toggle('has-one-slide', visibleCount <= 1);
  }

  handleThumb(event) {
    const target = event.target.tagName == "BUTTON" ? event.target : event.target.closest('button')
    // get index of slide based on image id
    const id = target.dataset.id
    const index = Array.from(this.mainSlides).indexOf(this.querySelector(`[data-main-slide][data-id="${id}"]`))
    
    this.activeIndex = index
    this.updateActiveImage()
  }

  handlePrevious() {
    // get visible slides
    const visibleSlides = this.getVisibleSlides()
    if(visibleSlides.length <= 1) return

    // find active index
    const visibleActiveIndex = visibleSlides.indexOf(this.querySelector(`[data-main-slide].is-active`))
    const newPosition = visibleActiveIndex - 1 < 0 ? visibleSlides.length - 1 : visibleActiveIndex - 1

    // find slide at new position
    const id = visibleSlides[newPosition].dataset.id
    this.activeIndex = Array.from(this.mainSlides).indexOf(this.querySelector(`[data-main-slide][data-id="${id}"]`))
    this.updateActiveImage()
  }

  handleNext() {
    // get visible slides
    const visibleSlides = this.getVisibleSlides()
    if(visibleSlides.length <= 1) return

    // find active index
    const visibleActiveIndex = visibleSlides.indexOf(this.querySelector(`[data-main-slide].is-active`))
    const newPosition = visibleActiveIndex + 1 >= visibleSlides.length ? 0 : visibleActiveIndex + 1

    // find slide at new position
    const id = visibleSlides[newPosition].dataset.id
    this.activeIndex = Array.from(this.mainSlides).indexOf(this.querySelector(`[data-main-slide][data-id="${id}"]`))
    this.updateActiveImage()
  }

  getVisibleSlides() {
    return Array.from(this.mainSlides || []).filter((el) => {
      return !el.classList.contains('is-hidden-variant-media') && el.style.display !== 'none';
    });
  }
}

customElements.define('new-product-gallery', NewProductGallery)

class NewVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.changeUrl = this.dataset.changeUrl;
    this.renderInfo = this.dataset.renderInfo;
    this.productBar = this.closest('product-section').querySelector('product-bar');

    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this.variantData = this.getVariantData()
    this.gallery = this.closest("product-section").querySelector("new-product-gallery")

    this.updateOptions()
    this.updateMasterId()
    this.updateVariantStatuses()

    this.updateVariantSelection()
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateMedia();
    if(!this.currentVariant) {
      // find available variant
      let availableVariant = this.variantData.find( (v) => v.title.includes(event.target.value))
      this.currentVariant = this.getVariantData().find((variant) => variant.id == availableVariant.id)
      // select new variant
      this.updateVariantSelection()
    }

    this.toggleAddButton(this.currentVariant ? this.currentVariant.available : false);
    this.updateVariantStatuses();
    this.updateSelectedValues();

    if (!this.currentVariant) {
      // this.toggleAddButton(false);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.handleCandle();
      if (this.changeUrl == 'true') this.updateURL();
      if (this.renderInfo != 'false') this.renderProductInfo();

      if (this.productBar) this.syncProductBar(event);
    }

    this.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: {
        variant: this.currentVariant,
        originalEvent: event
      }
    }));
    
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (this.getAttribute('data-section') == 'product-bar') return
    const sizeInput = this.querySelector('input[name="Size"]:checked, input[name="size"]:checked')
    if (sizeInput && window.FreshSendsVariantMedia && typeof window.FreshSendsVariantMedia.apply === 'function') {
      window.FreshSendsVariantMedia.apply(sizeInput.value)
    }
    const slider = this.closest('product-section').querySelector('new-product-gallery')
    if (!slider) return
    const newVariantImage = slider.querySelector(`[data-variants*="${this.currentVariant.id}"]:not(.is-hidden-variant-media)`)
    
    if (newVariantImage) {
      const slideToIndex = newVariantImage.getAttribute('data-index')
      if(this.gallery) {
        this.gallery.updateActiveIndex(slideToIndex)
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
      });
  }

  toggleAddButton(available) {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    
    if (button) {
      const addButton = button.querySelector('[name="add"]');
      if (available && addButton) {
        addButton.removeAttribute('disabled');
      } else {
        addButton.setAttribute('disabled', 'disabled');
      }
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form-input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    console.log(listOfAvailableOptions)
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.nextElementSibling.classList.remove('unavailable');
      } else {
        input.nextElementSibling.classList.add('unavailable');
      }

      if(listOfAvailableOptions.length <= 1) {
        listOfOptions[0].closest("fieldset").classList.add("unavailable")
      } else {
        listOfOptions[0].closest("fieldset").classList.remove("unavailable")
      }
    });
  }

  updateSelectedValues() {
    if (event.target.name == 'Color') {
      const value = event.target.value;
      event.target.closest('fieldset').querySelector('[data-selected-value]').innerHTML = value;
    }
  }

  syncProductBar(event) {
    const selected = event.target.value;
    const productBarButton = this.productBar.querySelector('[data-add-to-cart]');

    this.productBar.querySelector(`input[value="${selected}"]`).click();

    if (this.currentVariant.available) {
      productBarButton.removeAttribute('disabled');
    } else {
      productBarButton.setAttribute('disabled', 'disabled');
    }
  }

  handleCandle() {
    const candle = this.closest('form').querySelector('.addon--the-candle');
    if (candle) {
      if (this.currentVariant.title == 'Mini') {
        candle.classList.add('hidden');
      } else {
        candle.classList.remove('hidden');
      }
    }
  }
}

customElements.define('new-variant-selects', NewVariantSelects);

var NewVariantRadios = class extends NewVariantSelects {
  constructor() {
    super();
  }

  updateVariantSelection() {

    const options = this.currentVariant.options

    if ( options.length < 1) return

    options.forEach( (o, index) => {
      const selectedOption = this.querySelector(`[data-option-position="${index + 1}"] input[value="${o}"]`)
      if(selectedOption) {
        this.querySelector(`[data-option-position="${index + 1}"] input:checked`).checked = false
        selectedOption.checked = true
      }
    })

    this.dispatchEvent(new Event("change"))
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('new-variant-radios', NewVariantRadios);

customElements.define('card-product-slider', class cardProductSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperElemet = this.querySelector('.swiper');
    this.totalPages = parseInt(this.dataset.totalPages);
    this.collectionUrl = this.dataset.url;
    this._makePaginate();
    this._radioChangeAction();
    
  }
  async _makePaginate(){
   if(this.totalPages == 1){
     if(this.closest('product-card-model').isOpen) this._init();
     this.swiperElemet.closest('.js-step--wrapper').classList.remove('loading');
     return;
   }
    this.swiperElemet.closest('.js-step--wrapper').classList.add('loading');
    for (let index = 2; index <= this.totalPages; index++) {
      let responce = await fetch(`${this.collectionUrl}?page=${index}&section_id=product-gift-card-collection-products`);
      let data = await responce.text();
      let html = new DOMParser().parseFromString(data, 'text/html').querySelector('card-product-slider');
      this.querySelector('.swiper-wrapper').insertAdjacentHTML("beforeend", html.querySelector('.swiper-wrapper').innerHTML);
    }
    this.swiperElemet.closest('.js-step--wrapper').classList.remove('loading');
    if(this.closest('product-card-model').isOpen) this._init();
    this._radioChangeAction();
  }
  _init(){
    new Swiper(this.swiperElemet, {
      slidesPerView: 1,
      navigation: {
        nextEl: '.model-swiper-button-next',
        prevEl: '.model-swiper-button-prev',
      }
    });
  }
  _radioChangeAction(){
    this.querySelectorAll('[type="radio"][name="id"]').forEach(radio => {
      // console.log(1,radio)
      if(radio.classList.contains('js-event-added')) return;
      radio.classList.add('js-event-added');
      radio.onchange = (event) => {
        let button = radio.closest('.js-step--wrapper').querySelector('.btn-next-prev');
        button.disabled = false;
        button.classList.remove('disabled');
      };
    });
  }
});

customElements.define('product-card-model', class productCardModel extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.btn-next-prev').forEach(button => this._nextPrevAction(button));
    this.querySelector('.modal-close-button').onclick = () => this._close();
    this.querySelector('.js-tag-filter').onchange = (event) => this._filter(event);
    this.isOpen = false;
    this.catchFilter = [];
  }
  
  _nextPrevAction(button){
    button.onclick = (event) => {
      let perentElement = button.closest('.js-step--wrapper');
      perentElement.classList.add('hidden');
      if(button.dataset.action == "next"){
        perentElement.nextElementSibling.classList.remove('hidden');
      }else{
        perentElement.previousElementSibling.classList.remove('hidden');
      }
      setTimeout(() => {
        minHeight('.upcell-product-item', '.item-title');
      }, 50)
    };
  }
  _open(){   
    this.querySelector('.quick__shop--modal').classList.add('show__modal');
    this.querySelector('card-product-slider')._init();
    (window.sessionStorage.getItem('giftMessage') && (this.querySelector('[name="properties[Message]"]').value = atob(window.sessionStorage.getItem('giftMessage'))));
    this.isOpen = true;
    minHeight('.upcell-product-item', '.item-title');
    let productId = this.getAttribute("data-product-id");
    // console.log("productId", productId)

    fetch(window.location.pathname)
      .then(response => response.text())
      .then(data => {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = data;
        const targetProductModel = tempElement.querySelector(`product-card-model[data-product-id="${productId}"]`);
         if (targetProductModel) {
          const existingProductModel = document.querySelector(`product-card-model[data-product-id="${productId}"]`);
          if (existingProductModel) {
            const sectionStepFour = existingProductModel.querySelector('.section-step-four');
            if (sectionStepFour) {
              sectionStepFour.innerHTML = targetProductModel.querySelector('.section-step-four').innerHTML;
              const sectionStepFourElements = document.querySelectorAll(".section-step-four");
                sectionStepFourElements.forEach(sectionStepFour => {
                const addButtons = sectionStepFour.querySelectorAll(".add-upcell.button");
                const quantityInputs = sectionStepFour.querySelectorAll(".added-message");
              
                quantityInputs.forEach(input => {
                  input.style.display = "none";
                });
              
                addButtons.forEach((addButton, index) => {
                  addButton.addEventListener("click", function(event) {
                    event.preventDefault();
                    addButton.style.display = "none";
                    quantityInputs[index].style.display = "flex";
                  });
                });
                
                sectionStepFour.querySelector('.btn-next-prev').addEventListener('click', () => {
                  const stepThree = targetProductModel.querySelector('.section-step-three');
                  const stepFour = targetProductModel.querySelector('.section-step-four');
                  
                  if (stepThree && stepFour) {
                      stepThree.classList.toggle('hidden');
                      stepFour.classList.toggle('hidden');
                  }
                });
                this.querySelectorAll('.btn-next-prev').forEach(button => this._nextPrevAction(button));
              });
              if(!document.querySelector(".upcell-items-slider").classList.contains(".swiper-initialized")){
                var popupSwiperSlider = new Swiper('.upcell-items-slider', {
                  slidesPerView: 3,
                  spaceBetween: 25,
                  loop: false,
                  pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    type: "fraction",
                  }, 
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                  scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true
                  }
                });
              }
            }
          }
         }
      })
      .catch(error => console.error(error));
  }
  _close(reset = false){
    this.querySelector('.quick__shop--modal').classList.remove('show__modal');
    this.querySelector('card-product-slider').swiperElemet.swiper.destroy();
    window.sessionStorage.removeItem("productData");
    if(reset){
      this.querySelector('.js-step--wrapper:not(.hidden)').classList.add('hidden');
      let firstStep = this.querySelector('.js-step--wrapper');
      firstStep.classList.remove('hidden');
      firstStep.querySelector('input[type=radio]:checked').checked = false;
      firstStep.querySelector('.btn-next-prev').disabled = true;
      firstStep.querySelector('.btn-next-prev').classList.add('disabled');
    }
    this.isOpen = false;
  }
  _filter(){
    let select = event.currentTarget,
        wrapper = select.closest('.js-step--wrapper'),
        url = select.value;
    wrapper.classList.add('loading');
    const filterDataUrl = element => element.url === url;

    this.catchFilter.some(filterDataUrl) ? this._renderFromCatch(url,select) : this._renderFromFetch(url,select);
  }
  _renderFromCatch(url,select){
    let element = this.catchFilter.find(element => {
      return (element.url === url)
    });
    this._renderFilterData(element.data,select);
  }
  _renderFromFetch(url,select){
    fetch(`${url}?section_id=product-gift-card-collection-products`)
    .then(responce => {
      return responce.text();
    })
    .then(data => {
      this.catchFilter = [...this.catchFilter, { data, url }];
      this._renderFilterData(data,select);
    });
  }
  _renderFilterData(html,select){
    let newHTML = new DOMParser().parseFromString(html, 'text/html'),
        wrapper = select.closest('.js-step--wrapper'),
        button = wrapper.querySelector('.btn-next-prev');
    wrapper.querySelector('card-product-slider').replaceWith(newHTML.querySelector('card-product-slider'));
    button.disabled = true;
    button.classList.add('disabled');
  }
});
